module.exports = __webpack_public_path__ + "static/img/tan.63e7101f.svg";